import React, { Fragment, useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import queryString from "query-string";
import {
  Grid,
  Toolbar,
  Alert,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import Moment from "moment";

import loaderGif from "assets/img/loading.gif";

import { cardBodyStyle, AppBarStyle } from "components/cardBodyStyle";

import logo from "assets/img/logo.png";
import errorImg from "assets/img/error.png";
import successImg from "assets/img/success.gif";
import pendingImg from "assets/img/pending.png";

const useStyles = makeStyles(cardBodyStyle);

export default function PaymentResponse(props) {
  const classes = useStyles();

  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [loader, setLoader] = useState(true);
  const [alert, setAlert] = useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
    img: "",
  });

  const { urlServices } = useContext(UrlServicesContext);
  const location = useLocation();
  const params = queryString.parse(location.search);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RowsDatas();
  }, []);

  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 404) {
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
    setLoader(false);
  };

  const RowsDatas = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        `${urlServices}payment-transaction/transaction/${params.reference}`
      );
      if (response.status === 200) {
        submitRequestPay(
          response.data.id,
          response.data.requestIdTransaction,
          response.data.paymentTransactions
        );
      }
    } catch (error) {
      handleError(error);
    }
  };

  const submitRequestPay = async (id, requestId, dataClient) => {
    try {
      const response = await axios.post(
        `${urlServices}placetopay/view-pay/${requestId}`
      );
      if (response.status === 201) {
        const status = response.data.data.status;
        if (status.status === "REJECTED") {
          setAlert({
            openAlert: true,
            errorAlert: "error",
            mensaje: "Tu pago fue RECHAZADO",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: null,
            img: errorImg,
          });
        } else if (status.status === "APPROVED") {
          setAlert({
            openAlert: true,
            errorAlert: "success",
            mensaje: "Tu pago ha sido APROBADO y registrado exitosamente",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: response.data.data.payment[0].receipt,
            img: successImg,
          });
        } else if (status.status === "PENDING") {
          setAlert({
            openAlert: true,
            errorAlert: "warning",
            mensaje: "Tu pago está en estado PENDIENTE",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: null,
            img: pendingImg,
          });
        }
        submitSave(id, response.data.data, dataClient);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  const submitSave = async (id, data, dataClient) => {
    const dataValue = {
      responseTransaction: JSON.stringify(data),
      status:
        data.status.status === "APPROVED"
          ? 1
          : data.status.status === "REJECTED"
          ? 0
          : 3,
    };

    try {
      const response = await axios.put(
        `${urlServices}payment-transaction/${id}`,
        dataValue
      );
      if (response.status === 200) {
        await sendMail(data, dataClient);

        if (data.status.status === "APPROVED") {
          await updateStatusLink(dataClient);
        }

        setLoader(false);
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  const updateStatusLink = async (dataClient) => {
    try {
      const response = await axios.put(
        `${urlServices}payment-link/update-transaction/${dataClient.id}`,
        { status: 3 }
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  const sendMail = async (transaccion, dataClient) => {
    try {
      const client = {
        document: dataClient.documentId,
        documentType: dataClient.typeDocument,
        name: dataClient.name,
        surname: dataClient.lastName,
        email: dataClient.email,
        mobile: `${dataClient.phone}`,
        subTotal: dataClient.subTotal,
        iva: dataClient.iva,
        ivaTotal: dataClient.ivaSubtotal,
        payTotal: dataClient.total,
        paymentLinkId: dataClient.id,
        clientHost: dataClient.client.companyName,
        clientEmailHost: dataClient.client.email,
      };

      const values = {
        data: JSON.stringify(client),
        status: transaccion.status.status,
        reference: transaccion.request.payment.reference,
        date: Moment(transaccion.status.date).format("DD-MM-YYYY"),
        receipt: transaccion.payment ? transaccion.payment[0]?.receipt : null,
        authorization: transaccion.payment
          ? transaccion.payment[0]?.authorization
          : null,
      };

      const response = await axios.post(
        `${urlServices}payment-link/mail-transaction`,
        values
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  return (
    <Fragment>
      <AppBarStyle position="static">
        <Toolbar sx={{ minHeight: "50px !important" }}>
          <img
            src={logo}
            alt="logoheader"
            style={{ width: 70, marginLeft: "5%" }}
          />
        </Toolbar>
      </AppBarStyle>

      <center>
        <Grid
          container
          spacing={2}
          className={classes.containerProfile}
          sx={{ width: "80%", margin: "40px 0 0 8px" }}
        >
          <Grid item xs={12}>
            {error && <Alert severity="error">{mensageSystem}</Alert>}
          </Grid>
          {loader ? (
            <Grid item xs={12} sm={12}>
              <center>
                <img
                  alt="loaderGif"
                  src={loaderGif}
                  style={{ width: 60, margin: "20% 0" }}
                />
              </center>
            </Grid>
          ) : (
            <>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={alert.img}
                  alt="type"
                  style={{ width: 150, marginBottom: 20 }}
                />
                <Alert
                  severity={
                    alert.errorAlert === "success" ? "success" : "error"
                  }
                  icon={false}
                  sx={{ fontSize: 20 }}
                >
                  {alert.mensaje}
                </Alert>
                <br></br>
                <List sx={style}>
                  <ListItem>
                    <Grid container>
                      <Grid item xs={6} sm={6} sx={{ color: "#000" }}>
                        <b style={{ marginRight: 50 }}>Fecha</b>
                      </Grid>
                      <Grid item xs={6} sm={6} sx={{ color: "#000" }}>
                        <span style={{ float: "right" }}>
                          <ListItemText primary={alert.date} />
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />
                  <ListItem>
                    <Grid container>
                      <Grid item xs={6} sm={6} sx={{ color: "#000" }}>
                        <b style={{ marginRight: 50 }}>Referencia</b>
                      </Grid>
                      <Grid item xs={6} sm={6} sx={{ color: "#000" }}>
                        <span style={{ float: "right" }}>
                          <ListItemText primary={alert.reference} />
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />
                  <ListItem>
                    <Grid container>
                      <Grid item xs={6} sm={6} sx={{ color: "#000" }}>
                        <b style={{ marginRight: 50 }}>Valor</b>
                      </Grid>
                      <Grid item xs={6} sm={6} sx={{ color: "#000" }}>
                        <span style={{ float: "right" }}>
                          <ListItemText
                            primary={"$" + alert.price.toFixed(2)}
                          />
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  {alert.receipt && (
                    <>
                      <Divider component="li" />
                      <ListItem>
                        <Grid container>
                          <Grid item xs={6} sm={6} sx={{ color: "#000" }}>
                            <b style={{ marginRight: 50 }}>Recibo</b>
                          </Grid>
                          <Grid item xs={6} sm={6} sx={{ color: "#000" }}>
                            <span style={{ float: "right" }}>
                              <ListItemText primary={alert.receipt} />
                            </span>
                          </Grid>
                        </Grid>
                      </ListItem>
                    </>
                  )}
                </List>
              </Grid>
              {/*<Grid item xs={12} sx={{ paddingTop: 10 }}>
                <center>
                  <ButtonStyle0 href="https://usamebpo.com/">
                    Salir de la ventana
                  </ButtonStyle0>
                </center>
              </Grid>*/}
            </>
          )}
        </Grid>
      </center>
    </Fragment>
  );
}
